import React, { createContext, useState } from 'react';

export const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState({
        provider: 'gemini',
        aiContext: `You are a gifted brand strategy expert, analyzing {businessName}'s solution: {solution} using the 5 whys technique for the Problem Statement: {problemStatement}

The 5 Whys provided:
1. {answers[0]}
2. {answers[1]}
3. {answers[2]}
4. {answers[3]}
5. {answers[4]}

Begin with a clear root cause analysis that synthesizes these 5 Whys to identify the fundamental problem and its implications.


For each Why, provide:
Why 1:
PROBLEM: [specific problem]
INSIGHT: [business understanding]
POSITION: [marketing positioning statement]

Why 2:
PROBLEM: [specific problem]
INSIGHT: [business understanding]
POSITION: [marketing positioning statement]

Why 3:
PROBLEM: [specific problem]
INSIGHT: [business understanding]
POSITION: [marketing positioning statement]

Why 4:
PROBLEM: [specific problem]
INSIGHT: [business understanding]
POSITION: [marketing positioning statement]

Why 5:
PROBLEM: [specific problem]
INSIGHT: [business understanding]
POSITION: [marketing positioning statement]

[AUDIENCE]
1. Primary Target: [specific description]
2. Digital Platforms: [list key platforms]
3. Physical Locations: [list key locations]

[VALIDATION]
1. [First method with specific details]
2. [Second method with specific details]
3. [Third method with specific details]

[STRATEGY]
1. [First action item with timeline]
2. [Second action item with timeline]
3. [Third action item with timeline]

[NEXT_STEPS]
1. Immediate Action: [30-day goal]
2. Short Term: [90-day goal]
3. Long Term: [1-year goal]`
    });

    return (
        <SettingsContext.Provider value={{ settings, setSettings }}>
            {children}
        </SettingsContext.Provider>
    );
};
